import * as React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  useTranslate,
  useRecordContext,
  Toolbar,
  SaveButton,
} from 'react-admin';
import { Typography } from '@mui/material';

import SourceLanguageBanner from '../components/form/SourceLanguageBanner';
import { useSourceLanguage } from '../hooks/useSourceLanguage';

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton alwaysEnable />
  </Toolbar>
);

export const PageFormFields = ({ isEdit = false }) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const { localizedSource } = useSourceLanguage({ isEdit, record });

  return (
    <React.Fragment>
      <SourceLanguageBanner isEdit={isEdit} record={record} />

      <Typography variant="h6" sx={{ mb: 1, mt: 1 }}>
        {translate('loyaltyMobileAppsPage.form_heading', {
          _: 'Sadakat Uygulamaları Sayfası',
        })}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        {translate('loyaltyMobileAppsPage.form_subheading', {
          _: 'Mobil sadakat listesinin üstündeki sayfa başlığı.',
        })}
      </Typography>

      <TextInput
        source={localizedSource('heading')}
        label={translate('loyaltyMobileAppsPage.heading', { _: 'Sayfa Başlığı' })}
        fullWidth
        validate={required()}
      />
    </React.Fragment>
  );
};

/** Singleton — seed id: default (ayrı menü yok; Sadakat Uygulamaları sekmesinden) */
export const LoyaltyMobileAppsPageEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit
      title={translate('loyaltyMobileAppsPage.edit_title', {
        _: 'Sadakat Sayfa Başlığı',
      })}
      {...props}
      id="default"
      mutationMode="pessimistic"
    >
      <SimpleForm redirect={false} toolbar={<FormToolbar />}>
        <PageFormFields isEdit />
      </SimpleForm>
    </Edit>
  );
};
